module.exports = __webpack_public_path__ + "static/media/pencil_pot_1.7f4d1918.png";